// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-088a76b8]{overflow-x:hidden;overflow-y:auto}.modal-mask[data-v-088a76b8]{position:fixed;z-index:10000;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.5);display:table;transition:opacity 0.3s ease}.modal[data-v-088a76b8] .center-content-position{width:90%;margin:auto}@media (min-width: 768px){.modal[data-v-088a76b8] .center-content-position{width:40%}}\n", ""]);
// Exports
module.exports = exports;
